function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useContext, useMemo, useState } from 'react';
import cx from 'clsx';
import { observer } from 'mobx-react-lite';
import Store from '@unmapped/core/state/Store';
import Unmapped from '@unmapped/core/Unmapped';
import { decorateName } from '@unmapped/core/utils';
import ResultsList from '@unmapped/core-ui/results/ResultsList';
import FilterFieldset from '@unmapped/core-ui/layouts/FilterFieldset';
import GeoRadiusFilter from '@unmapped/core-ui/filters/GeoRadiusFilter';
import { CheckboxFilter } from '@unmapped/core-ui/filters/CheckboxFilter';
import FuzzySearchFilter from '@unmapped/core-ui/filters/FuzzySearchFilter';
import TwoColumnOverlayMapLayout from '@unmapped/core-ui/layouts/TwoColumnOverlayMapLayout';
import { adapterMap } from './definitions/shared';
import { FocusedLocationContext, useDataSource, useFilterSet, useSortManager } from './hooks';
import MapWrapper from './MapWrapper';
import ResultItem from './overrides/ResultItem';
import PopoverContent from './overrides/PopoverContent';
import { ACTIVE_DATASET } from '../apiConfig';
import { blindAssert } from './utils';
export const GenericFinder = observer(_ref => {
  let {} = _ref;
  let dataset = ACTIVE_DATASET;
  const filterSet = useFilterSet(dataset);
  const [focusedLocation, setFocusedLocation] = useState(null);
  const store = useMemo(() => new Store(filterSet, adapterMap[dataset]), []);
  useDataSource(dataset, store);
  return /*#__PURE__*/React.createElement(Unmapped, {
    store: store
  }, /*#__PURE__*/React.createElement(FocusedLocationContext.Provider, {
    value: {
      focusedLocation,
      setFocusedLocation
    }
  }, /*#__PURE__*/React.createElement(TwoColumnOverlayMapLayout, {
    sidebarLocation: "right",
    components: {
      'results/ResultItem': ResultItem,
      'GoogleMaps/Popover/PopoverContent': PopoverContent
    },
    styles: (name, classNames) => {
      if (name === 'controls/CheckboxInput') {
        blindAssert(classNames);
        return _objectSpread(_objectSpread({}, classNames), {}, {
          'CheckboxContainer': cx(classNames.CheckboxContainer, 'custom-control', 'custom-checkbox'),
          'CheckboxInput': cx(classNames.CheckboxInput, 'custom-control-input'),
          'CheckboxLabel': cx(classNames.CheckboxLabel, 'custom-control-label'),
          'CheckboxLabelText': cx(classNames.CheckboxLabelText, 'custom-control-label-text')
        });
      } else return classNames[name];
    },
    sidebar: /*#__PURE__*/React.createElement(FilterFieldset, {
      filters: [['distance', /*#__PURE__*/React.createElement(GeoRadiusFilter, {
        name: "distance"
      }), 'Find Near'], ['grades', /*#__PURE__*/React.createElement(CheckboxFilter, {
        name: "grades",
        showSelectAll: false
      }), 'Grades Taught'], ['grantEligibility', /*#__PURE__*/React.createElement(CheckboxFilter, {
        name: "grantEligibility",
        showSelectAll: false
      }), ' '], ['operator', /*#__PURE__*/React.createElement(CheckboxFilter, {
        name: "operator",
        showSelectAll: false
      }), ' ']]
    }),
    map: /*#__PURE__*/React.createElement(MapWrapper, null),
    results: /*#__PURE__*/React.createElement(ResultsView, null)
  })));
});
export default GenericFinder;
const ResultsView = decorateName(observer(_ref2 => {
  let {} = _ref2;
  useSortManager();
  const {
    setFocusedLocation
  } = useContext(FocusedLocationContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FuzzySearchFilter, {
    name: "search",
    showSortIndicator: true
  }), /*#__PURE__*/React.createElement(ResultsList, {
    onResultClick: (r, e) => {
      e.preventDefault();
      e.stopPropagation();
      setFocusedLocation(r);
    }
  }));
}), 'ResultView');